/** @jsx jsx */
import { jsx } from 'theme-ui';
import { getFreeSlotsByAppointmentTypeAction, useApi, } from '@getclarauk/api-client';
import { useState, useMemo, Fragment, useEffect } from 'react';
import { DayPicker } from './DayPicker';
import { SlotSections } from './SlotSections';
import { dayjs } from '../util/dayjs';
import { TextSkeleton } from './TextSkeleton';
import { RepeatComponent } from './RepeatComponent';
var defaultNumberOfDays = 5;
// special value meaning no time has been selected
// it's not actually possible to book an appointment for this time
export var NO_TIME = '00:01';
export var SlotPicker = function (_a) {
    var className = _a.className, pharmacyId = _a.pharmacyId, appointmentTypeId = _a.appointmentTypeId, value = _a.value, onChange = _a.onChange;
    var _b = useState(dayjs().tz('Europe/London')), start = _b[0], setStart = _b[1];
    var _c = useState(defaultNumberOfDays), numberOfDays = _c[0], setNumberOfDays = _c[1];
    var _d = useApi(getFreeSlotsByAppointmentTypeAction), getFreeSlotsByAppointmentType = _d[0], busy = _d[1];
    var _e = useState({}), groupedSlots = _e[0], setGroupedSlots = _e[1];
    var _f = useState(true), seekToFirst = _f[0], setSeekToFirst = _f[1];
    useEffect(function () {
        getFreeSlotsByAppointmentType({
            pharmacyId: pharmacyId,
            appointmentTypeId: appointmentTypeId,
            start: start.toDate(),
            numberOfDays: numberOfDays,
            seekToFirst: seekToFirst,
        }).then(function (slots) {
            var end = start.add(numberOfDays - 1, 'day').format('YYYY-MM-DD');
            var first = slots.map(function (x) { return x.day; }).sort()[0];
            if (seekToFirst && first && first > end) {
                setStart(dayjs(first));
                setSeekToFirst(false);
                return;
            }
            var days = {};
            for (var _i = 0, slots_1 = slots; _i < slots_1.length; _i++) {
                var slot = slots_1[_i];
                if (!days[slot.day]) {
                    days[slot.day] = new Set();
                }
                days[slot.day].add(slot.time);
            }
            var result = {};
            for (var day in days) {
                result[day] = Array.from(days[day]);
            }
            setGroupedSlots(result);
        });
    }, [
        appointmentTypeId,
        getFreeSlotsByAppointmentType,
        numberOfDays,
        pharmacyId,
        seekToFirst,
        start,
    ]);
    var todaysSlots = useMemo(function () {
        if (!value)
            return [];
        return groupedSlots[value.format('YYYY-MM-DD')] || [];
    }, [groupedSlots, value]);
    return (jsx("div", { className: className },
        jsx(DayPicker, { start: start.format('YYYY-MM-DD'), onStartChange: function (day) { return setStart(dayjs(day)); }, value: (value === null || value === void 0 ? void 0 : value.format('YYYY-MM-DD')) || dayjs().format('YYYY-MM-DD'), values: groupedSlots, onChange: function (day) {
                onChange(dayjs(day + ' ' + NO_TIME));
            }, numberOfDays: numberOfDays, onNumberOfDaysChange: setNumberOfDays }),
        jsx("div", { sx: { mt: 3 } }, busy ? (jsx(Fragment, null,
            jsx(TextSkeleton, { line: true, sx: { width: 70, mb: 3 } }),
            jsx(RepeatComponent, { count: 10 },
                jsx(ButtonSkeleton, null)),
            jsx(TextSkeleton, { line: true, sx: { width: 70, mb: 3 } }),
            jsx(RepeatComponent, { count: 10 },
                jsx(ButtonSkeleton, null)),
            jsx(TextSkeleton, { line: true, sx: { width: 70, mb: 3 } }),
            jsx(RepeatComponent, { count: 10 },
                jsx(ButtonSkeleton, null)))) : !todaysSlots.length ? (jsx("div", { sx: { color: 'muted', textAlign: 'center', my: 4 } }, "No appointments available on this day.")) : (jsx(SlotSections, { slots: todaysSlots, value: value === null || value === void 0 ? void 0 : value.format('HH:mm'), onChange: function (time) {
                onChange(dayjs.tz((value === null || value === void 0 ? void 0 : value.format('YYYY-MM-DD')) + ' ' + time, 'Europe/London'));
            } })))));
};
var ButtonSkeleton = function () {
    return (jsx(TextSkeleton, { sx: {
            width: 50,
            m: 1,
            py: 1,
            fontSize: 1,
            height: '1.5em',
            boxSizing: 'content-box',
        } }));
};
//# sourceMappingURL=SlotPicker.js.map